<template>
  <div class="boxbgcolor api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right configure-right">
      <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="payConfigure">
        <el-form-item label="商户号" prop="mchid">
          <el-input v-model="payConfigure.mchid" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="密钥" prop="apikey">
          <el-input v-model="payConfigure.apikey" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
        </el-form-item>
      </el-form>
      <div class="submit">
        <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  ningxiaUnionPayUnionConfigureOne,
  ningxiaUnionPayUnionConfigureAddOrEdit,
} from "@/api/url";

import AreaTree from "@/page/commons/areaTree";

import Cookies from "js-cookie";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      fileList: [],
      payConfigure: {
        id: "",
        // systemname:'',
        mchid: "",
        apikey: "",
        // secret:'',
        openFlag: false,
        parkingId: "",
      },
      headers: {
        Authorization: Cookies.get("Authorization"), //从cookie里获取token，并赋值  Authorization ，而不是token
      },
      rules: {
        // systemname: [
        //     { required: true, message: '请填写系统名称', trigger: 'blur' }
        // ],
        mchid: [{ required: true, message: "请填商户号", trigger: "blur" }],
        apikey: [{ required: true, message: "请填写密钥", trigger: "blur" }],
        // secret: [
        //     {  required: true, message: '请填写公钥', trigger: 'blur' }
        // ],
        // openFlag: [
        //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
        // ]
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),

    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.treeData.parkingId = "";
        this.payConfigure.id = "";
        this.payConfigure.mchid = "";
        this.payConfigure.signCertificatePassword = "";
        this.payConfigure.openFlag = false;
        // this.$message({
        //         message: '请选择车场！',
        //         type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(ningxiaUnionPayUnionConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          this.treeData.parkingId = data.data.parkingId;
          this.payConfigure.id = data.data.id;
          this.payConfigure.mchid = data.data.mchid;
          this.payConfigure.apikey = data.data.apikey;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
        } else {
          // this.treeData.parkingId='';
          // this.payConfigure.systemname='';
          this.payConfigure.id = "";
          this.payConfigure.mchid = "";
          this.payConfigure.apikey = "";
          // this.payConfigure.secret='';
          this.payConfigure.openFlag = false;
        }
      });
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          this.$postRequest(ningxiaUnionPayUnionConfigureAddOrEdit(), {
            id: this.payConfigure.id,
            parkingId: this.treeData.parkingId,
            // systemname:this.payConfigure.systemname,
            mchid: this.payConfigure.mchid,
            // secret:this.payConfigure.secret,
            apikey: this.payConfigure.apikey,
            openFlag: this.payConfigure.openFlag ? "y" : "n",
          }).then((data) => {
            //提交后的操作
            if (data.status != 200) return this.$layer.msg(data.message);
            this.$notify({
              type: "success",
              title: "成功",
              message: "新增或修改配置成功!",
            });
          });
        } else {
        }
      });
    },
    // uploadError(){
    //     this.$notify({
    // 				type:'error',
    // 				title:'上传失败',
    // 				message:'请检查文件类型,重新上传!'
    // 			})
    // },
    //  uploadSuccess(){
    //      this.$notify({
    // 				type:'success',
    // 				title:'成功',
    // 				message:'文件上传成功!'
    // 			})
    //  },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {},
  components: {
    AreaTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.boxbgcolor {
}
.submit {
  text-align: center;
}
.uploadTxt {
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 45px;
  line-height: 45px;
  padding-left: 5px;
}
.api-configure .el-upload__tip {
  height: 30px;
  line-height: 30px;
}
.api-configure .el-upload__tip {
  color: red !important;
}
</style>
<style>
.api-configure .el-form {
  width: 70%;
  margin: 0 auto;
  margin-top: 50px;
}
.api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
}
.api-configure .el-form-item {
  margin-bottom: 30px;
}
.api-configure .el-form-item__label {
  height: 50px;
  line-height: 50px;
  color: #333 !important;
  font-weight: bold;
}
.submit .el-button {
  width: 200px;
  height: 50px;
}
.api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
</style>